// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"918a1161","699":"74f6b0f5"}[chunkId] + ".chunk.css";
};